$(document).ready(function(){
   var cafeemail = $('.custombase').find(':selected').attr('data-email');
 var cafename = $('.custombase').val();
      $('#custom_fulfillment_service').val(cafeemail);
       $('#custom_fulfillment_servicebase').val(cafename);
      $('#custom_fulfillment_servicename').val(cafename);
     
    $(document).on("change",".custombase", function(){
     var cafeemail = $(this).find(':selected').attr('data-email');
       var cafename =$(this).val();
       $('#custom_fulfillment_service').val(cafeemail);
       $('#custom_fulfillment_servicebase').val(cafename);
      $('#custom_fulfillment_servicename').val(cafename);
    });
   
 });
